import {
    CANCEL_BOOKING,
    CANCEL_BOOKING_FAILURE,
    CANCEL_BOOKING_SUCCESS,
} from 'store/actions/types';

export const cancelBooking = (payload) => {
    return {
        type: CANCEL_BOOKING,
        payload: payload,
    };
};

export const cancelBookingFailure = (error) => {
    return {
        type: CANCEL_BOOKING_FAILURE,
        error: error,
    };
};

export const cancelBookingSuccess = (response) => {
    return {
        type: CANCEL_BOOKING_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookings/cancelBookings.js